# toggle
#
# Provides global toggling behavior by controlling the active state for all
# toggles in the page. Only one toggle can be active at any point in time. Each
# $scope listens for events from other toggles. If one is activated any other
# active toggles will be go inactive. Also if the user clicks anywhere else the
# all toggles will be set inactive.
#
angular.module('wbServices').service 'toggle', ['$rootScope', ($rootScope) ->
  # Trigger all toggles to close when anything else is clicked
  $(document).on 'click', (e) ->
    $rootScope.$broadcast('toggled', { active: true })
    $rootScope.$apply()

  class ToggleService
    register: ($scope) ->
      $scope.active = false

      # Close toggle whenever another is opened
      $scope.$on 'toggled', (event, toggleScope) ->
        return if !toggleScope.active or toggleScope is $scope
        $scope.active = false

    toggle: ($scope) ->
      $scope.active = !$scope.active
      $rootScope.$broadcast('toggled', $scope)

  return new ToggleService()
]
